<template>
  <v-dialog v-model="openDialog" max-width="90%" @click:outside="close">
    <v-card>
      <v-card-title>
        <span class="headline">Versões do Registro</span>
      </v-card-title>
      <v-card-text>
        <historico-registro
          :registroSelecionado="registroSelecionado"
          @inativar-registro="inativarRegistro(registroSelecionado.entidadeID)"
        ></historico-registro>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="close"> Fechar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import HistoricoRegistro from "@/views/components/HistoricoRegistro.vue";
import "vue-pdf-app/dist/icons/main.css";
export default {
  name: "ModalDialogHistorico",
  data() {
    return {
      openDialog: false,
    };
  },
  watch: {
    dialogHistorico: function (newDialogHistorico) {
      this.openDialog = newDialogHistorico;
    },
  },
  components: {
    HistoricoRegistro,
  },
  props: {
    registroSelecionado: Object,
    dialogHistorico: {
      type: Boolean,
      required: true,
    },
  },

  methods: {
    close() {
      this.$emit("close");
    },
    inativarRegistro(entidade) {
      this.$emit("inativar-registro", entidade);
    },
  },
};
</script>
